import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { EntityService } from '../../services/entity.service';
import { EntityEditComponent } from '../entity-edit/entity-edit.component';
import { NoteService } from "../../services/note.service";

@Component({
  selector: 'app-sl-view',
  templateUrl: './sl-view.component.html',
  styleUrls: ['./sl-view.component.scss']
})
export class SlViewComponent implements OnInit,OnChanges {

  @Input() showEditable=false;
  @Input() entitiesData;
  @Input() sAccount;
  @Input() sVersion;
  @Input() healthHideEntities;
  @Input() entityViewType;
  @Input() pageView = 0;

  // how many vertical blocks each section has
  // recalced to handle overflows
  row1vblocks=1;
  row2vblocks=1;
  row3vblocks=1;
  row4vblocks=1;
  row5vblocks=1;
  row6vblocks=1;

  col1vblocks=2;
  col2vblocks=2;
  col3vblocks=2;
  col4vblocks=2;
  col5vblocks=2;

  areaCounts=[];

  entityData = {
    bps: {
      area: ['bps','bpaas','insurance'],
      data: []
    },
    devices: {
      area: ['devices'],
      data: []
    },
    collaboration: {
      area: ['collaboration'],
      data: []
    },
    asset: {
      area: ['asset'],
      data: []
    },
    engineering: {
      area: ['engineering'],
      data: []
    },
    analytics: {
      area: ['analytics'],
      data: []
    },
    data: {
      area: ['data'],
      data: []
    },
    managedapp: {
      area: ['managedapp'],
      data: []
    },
    enterpriseapp: {
      area: ['enterpriseapp'],
      data: []
    },
    modernization: {
      area: ['modernization'],
      data: []
    },
    iaas: {
      area: ['iaas'],
      data: []
    },
    paas: {
      area: ['paas'],
      data: []
    },
    hybrid: {
      area: ['hybrid'],
      data: []
    },
    server: {
      area: ['server'],
      data: []
    },
    mainframe: {
      area: ['mainframe'],
      data: []
    },
    storage: {
      area: ['storage'],
      data: []
    },
    datacenter: {
      area: ['datacenter'],
      data: []
    },
    network: {
      area: ['network'],
      data: []
    },
    security: {
      area: ['security'],
      data: []
    },
    systemsupport: {
      area: ['systemsupport'],
      data: []
    },
    consulting: {
      area: ['consulting'],
      data: []
    },
    analysts: {
      area: ['analysts'],
      data: []
    },
  };

  rowAreaHeight = {
    row1: {
      rowHeight: '',
      areaHeight: ''
    },
    row2: {
      rowHeight: '',
      areaHeight: ''
    },
    row3: {
      rowHeight: '',
      areaHeight: ''
    },
    row4: {
      rowHeight: '',
      areaHeight: ''
    },
    row5: {
      rowHeight: '',
      areaHeight: ''
    },
    row6: {
      rowHeight: '',
      areaHeight: ''
    }
  };

  avgRowHeight = 130;
  avgEntityHeight = 125;
  areaBorderHeight = 4;

  constructor(
    public entityService: EntityService,
    public dialog: MatDialog,
    public noteService:NoteService,
  ) { }

  ngOnInit(): void {
    this.getHeights();
  }

  ngOnChanges(){
    this.getHeights();
  }

  getEntity(area){

    if(!this.entitiesData) return [];

    // if its not an array then turn it into one
    if(!Array.isArray(area)) area = [area];

    // if this is the health view then only show enities with a health status
    // if the checkbox is ticked
    let rtn = [];

    // step through each area in turn to peserve the area order passed
    area.forEach(a => {
      if(this.entityViewType=="health" && this.healthHideEntities){
        rtn.push(...this.entitiesData.filter(x => (x.area.toLowerCase() == a && (x.healthstatus!="" && x.healthstatus!=null))).sort((x, y) => parseInt(x.displayorder) > parseInt(y.displayorder) ? 1 : -1))
      } else {
        rtn.push(...this.entitiesData.filter(x => (x.area.toLowerCase() == a)).sort((x, y) => parseInt(x.displayorder) > parseInt(y.displayorder) ? 1 : -1))
      }
    });
    //rtn.sort((x, y) => (parseInt(x.displayorder) > parseInt(y.displayorder)) ? 1 : -1);
    // console.log(rtn);
    return rtn;
  }

  getTotalRows(){
    let x= 0;
    x+= this.row1vblocks
    x+= this.row2vblocks
    x+= this.row3vblocks
    x+= this.row4vblocks
    x+= this.row5vblocks
    x+= this.row6vblocks
    return x
  }

  getRowHeightNumber(x) {
    return (x * this.avgEntityHeight) + 20 + this.areaBorderHeight;
  }

  getRowHeight(x){
    return this.getRowHeightNumber(x) + "px";
  }

  getAreaHeight(x){
    return ((x * this.avgEntityHeight) + 20) + "px";
  }

  getInfraHeight(){
    const row5Height = this.getRowHeightNumber(this.row5vblocks);
    const row6Height = this.getRowHeightNumber(this.row6vblocks);
    return (row5Height + row6Height + 20) + "px";
  }

  getC1Height(){
    return 45 + (this.avgRowHeight * (this.col1vblocks)) + "px"
  }

  getC2Height(){
    return 25 + (this.avgRowHeight * (this.col2vblocks)) + "px"
  }

  getC3Height(){
    return 15 + (this.avgRowHeight * (this.col3vblocks)) + "px"
  }

  getC4Height(){
    return 25 + (this.avgRowHeight * (this.col4vblocks)) + "px"
  }

  getC5Height(){
    return 25 + (this.avgRowHeight * (this.col5vblocks)) + "px"
  }

  public addEntity(){
    this.openEntityEdit({});
  }

  // handle expanding the rows if we have more entities than will fit
  getHeights(){
    for (const [key, value] of Object.entries(this.entityData)) {
      this.entityData[key].data = this.getEntity(value.area);
    }

    // bps has 2 slots, devices 2 slots and collaboration 2 slots, asset has 1 slot
    let r1 = Math.max(1,this.entityData.bps.data.length / 2,this.entityData.devices.data.length / 2,this.entityData.collaboration.data.length / 2, this.entityData.asset.data.length);
    this.row1vblocks = Math.ceil(r1);

    // engineering has 2 slosts, analytics has 2 slots, data has 2 blocks
    let r2 = Math.max(1,this.entityData.engineering.data.length/2,this.entityData.analytics.data.length/2,this.entityData.data.data.length/2)
    this.row2vblocks = Math.ceil(r2);

    // managedapp, enterpriseapp, modernization all have 2 slots
    let r3 = Math.max(2,this.entityData.managedapp.data.length,this.entityData.enterpriseapp.data.length,this.entityData.modernization.data.length);
    this.row3vblocks = Math.ceil(r3/2);

    // iaas has 2 slots, paas has 2 slots, hybrid has 3 slots
    let r4 = Math.max(1,this.entityData.iaas.data.length/2,this.entityData.paas.data.length/2,this.entityData.hybrid.data.length/3)
    this.row4vblocks = Math.ceil(r4);

    // server has 2, mainframe 1, storage 2
    let r5 = Math.max(1,this.entityData.server.data.length/2,this.entityData.mainframe.data.length,this.entityData.storage.data.length/2)
    this.row5vblocks = Math.ceil(r5);

    // data center has 5
    let r6 = Math.max(1,this.entityData.datacenter.data.length/5);
    this.row6vblocks = Math.ceil(r6);

    // network has r5+r6 slots - if it is more than 2 then make the bottom row bigger to match if required
    let slots = (this.row5vblocks+this.row6vblocks)
    this.col1vblocks = this.entityData.network.data.length
    if(this.col1vblocks>slots){
        this.row6vblocks = this.col1vblocks - this.row5vblocks;
    } else {
      this.col1vblocks = slots;
    }

    // security has r2+r3 slots - if it is more than 2 then make row3 bigger (if required)
    slots = (this.row2vblocks+this.row3vblocks)
    this.col2vblocks = this.entityData.security.data.length
    if(this.col2vblocks>slots){
        this.row3vblocks = this.col2vblocks - this.row2vblocks;
    } else {
      this.col2vblocks = slots;
    }

    // system support has (r5+r6) slots - if its more than 2 then make row6 bigger if required
    slots = (this.row5vblocks+this.row6vblocks)
    this.col3vblocks = Math.ceil(this.entityData.systemsupport.data.length / 2)
    if(this.col3vblocks>slots){
        this.row6vblocks = this.col3vblocks - this.row5vblocks;
        // adjust network size as well if we increase the size
        this.col1vblocks = this.col3vblocks;
    } else {
      this.col3vblocks = slots;
    }

    // consulting has r1+r2 slots - if it is more than 2 then make row2 bigger (if required)
    slots = this.row1vblocks+this.row2vblocks;
    this.col4vblocks = this.entityData.consulting.data.length
    if(this.col4vblocks>slots){
        this.row2vblocks = this.col4vblocks - this.row1vblocks;
    } else {
      this.col4vblocks = slots;
    }

    // analysts has r3+r4 slots - if it is more than 2 then make row4 bigger (if required)
    slots = (this.row3vblocks+this.row4vblocks)
    this.col5vblocks = this.entityData.analysts.data.length
    if(this.col5vblocks>slots){
        this.row4vblocks = this.col5vblocks - this.row3vblocks;
    } else {
      this.col5vblocks = slots;
    }

    Object.keys(this.rowAreaHeight).forEach(row => {
      const blockField = `${row}vblocks`;
      this.rowAreaHeight[row].rowHeight = this.getRowHeight(this[blockField]);
      this.rowAreaHeight[row].areaHeight = this.getAreaHeight(this[blockField]);
    });
  }

  editEntity(id){
    // find the data row and pass to the edit
    const d = this.entitiesData.filter(x => (x.id == id))
    if(d.length==1) this.openEntityEdit(d[0]);
  }

  openEntityEdit(data){

    if(!this.showEditable) return false;

    let newdata = this.deepCopy(data);
    newdata["selectedTab"] = (this.getEntityViewType() == 'landscape' ? 0 : 1 );
    newdata["entitiesData"] = this.entitiesData;
    newdata["sAccount"] = this.sAccount;
    newdata["sVersion"] = this.sVersion;

    // pass the count of Entities in each area so it knows what to show in the order drop down
    let areaCounts = {};
    this.entitiesData.forEach(x => {
      if(areaCounts[x.area] == null ) {
        areaCounts[x.area]=1;
      } else {
        areaCounts[x.area]=areaCounts[x.area]+1;
      }
    });

    newdata["areaCounts"] = areaCounts;


    let dialogRef = this.dialog.open(EntityEditComponent, {
      height: '630px',
      width: '700px',
      data: newdata
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){

      } else if(result=="delete"){

        // delete from the database
        this.entityService.deleteEntity(newdata);

        // update the order list for this area - just update in order - don't need to save in the database
        // cause the order hasn't actually changed
        let cnt = 1;
        this.entitiesData.sort((x, y) => (x.displayorder > y.displayorder) ? 1 : -1).forEach((x) => {
          if(x.area == newdata["area"]){
            if(x.id != newdata["id"]){
              this.entityService.updateEntitySortOrder(x.id,cnt);
              cnt++;
            }
          }
        });



      } else if(result!=undefined){
        let slNewNote = result['slNewNote'];
        let hvNewNote = result['hvNewNote'];
        let geNewNote = result['geNewNote'];
        if(result["slNewNote"]) delete result["slNewNote"]; 
        if(result["hvNewNote"]) delete result["hvNewNote"];
        if(result["geNewNote"]) delete result["geNewNote"];

        // add in the account and the version
        result["accountid"] = this.sAccount["id"];
        result["versionid"] = this.sVersion;

        // save to the database
        this.entityService.updateEntity(result).then(
          (res:object) => { 
            if(slNewNote){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'landscape',
                'comment': slNewNote
              });
            }
            if(hvNewNote){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'health',
                'comment': hvNewNote
              });
            }
            if(geNewNote){
              this.noteService.updateNotes({
                'id':0, 
                'entityid': res["id"],
                'versionid': res["data"][0].versionid,
                'notetype': 'general',
                'comment': geNewNote
              });
            }
          },
          (err) => { alert(err);}
        );

        // redo the order list for this area - remember the vals so we can save
        let updateSort = [];
        let cnt = 1;
        let newdo = result["displayorder"];
        let originaldo = result["originalDisplayOrder"]!=undefined ? result["originalDisplayOrder"] : 9999 ;
        // console.log("newdo:" + newdo + " originaldo:" + originaldo)
        this.entitiesData.sort((x, y) => (x.displayorder > y.displayorder) ? 1 : -1).forEach((x) => {
          if(x.area == result["area"]){
            if(x.id != result["id"]){
              if(x.displayorder < originaldo && x.displayorder >= newdo){
                // console.log("--udpate " + x.servicename + " to:" + ((+x.displayorder) + 1))
                x.displayorder = (+x.displayorder) + 1
                this.entityService.updateEntitySortOrder(x.id,x.displayorder);
                updateSort.push({accountid:this.sAccount["id"],versionid:this.sVersion,id:x["id"],displayorder:x.displayorder})
              } else if (x.displayorder > originaldo && x.displayorder <= newdo) {
                // console.log("--udpate " + x.servicename + " to:" + ((+x.displayorder) - 1))
                x.displayorder = (+x.displayorder) - 1
                this.entityService.updateEntitySortOrder(x.id,x.displayorder);
                updateSort.push({accountid:this.sAccount["id"],versionid:this.sVersion,id:x["id"],displayorder:x.displayorder})
              }
            }
          }
        });

        if(updateSort.length>0){
          this.entityService.updateEntitySort(updateSort);
        }

      }
    })
  }



    // what is the entity type - depends on page
    getEntityViewType(){
      return this.entityViewType;
    }

      // deep copy of Object
      private deepCopy(obj) {
        return Object.keys(obj).reduce((v, d) => Object.assign(v, {
          [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
        }), {});
      }



}
